(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tmw-new-arrival-markets"] && !Shopify.designMode) return;
  try {
    
  const initializeTmwArrivalMarkets = (root) => {
    if (!root || root.dataset.tmwArrivalReady === 'true') return;
    root.dataset.tmwArrivalReady = 'true';
    const initialCount = Number(root.dataset.initialCount || 4);
    const loadStep = Number(root.dataset.loadStep || 6);
    const panels = Array.from(root.querySelectorAll('[data-arrival-panel]'));
    const moreButton = root.querySelector('[data-arrival-more]');

    const updateMoreButton = () => {
      if (!moreButton) return;
      const hasMore = panels.some((panel) => panel.querySelector('.tmw-product-list__item[hidden]'));
      moreButton.hidden = !hasMore;
      moreButton.setAttribute('aria-expanded', String(!hasMore));
    };

    panels.forEach((panel) => {
      panel.querySelectorAll('.tmw-product-list__item').forEach((item, index) => {
        item.hidden = index >= initialCount;
      });
    });

    root.querySelectorAll('[data-arrival-tab]').forEach((button) => {
      button.addEventListener('click', () => {
        const key = button.dataset.arrivalTab;
        const update = () => {
          root.querySelectorAll('[data-arrival-tab]').forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.arrivalTab === key)));
          panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.arrivalPanel === key));
        };
        if (document.startViewTransition) document.startViewTransition(update); else update();
      });
    });

    if (moreButton) {
      moreButton.addEventListener('click', () => {
        panels.forEach((panel) => {
          Array.from(panel.querySelectorAll('.tmw-product-list__item[hidden]')).slice(0, loadStep).forEach((item) => {
            item.hidden = false;
          });
        });
        updateMoreButton();
      });
    }
    updateMoreButton();
  };

  if (!customElements.get('tmw-arrival-markets')) {
    customElements.define('tmw-arrival-markets', class extends HTMLElement {
      connectedCallback() {
        initializeTmwArrivalMarkets(this);
      }
    });
  }
  document.querySelectorAll('tmw-arrival-markets').forEach(initializeTmwArrivalMarkets);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tmw-post-archive"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tmw-post-archive')) {
    customElements.define('tmw-post-archive', class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-archive-filter]').forEach((button) => button.addEventListener('click', () => this.filter(button.dataset.archiveFilter)));
        this.querySelectorAll('[data-open-post]').forEach((button) => button.addEventListener('click', () => document.getElementById(button.dataset.openPost)?.showModal()));
        this.querySelectorAll('.tmw-post-dialog').forEach((dialog) => {
          dialog.dataset.index = '0';
          dialog.querySelector('[data-close-post]')?.addEventListener('click', () => this.closeDialog(dialog));
          dialog.querySelector('[data-dialog-prev]')?.addEventListener('click', () => this.step(dialog, -1));
          dialog.querySelector('[data-dialog-next]')?.addEventListener('click', () => this.step(dialog, 1));
          dialog.addEventListener('click', (event) => { if (event.target === dialog) this.closeDialog(dialog); });
          dialog.addEventListener('close', () => dialog.querySelectorAll('video').forEach((video) => video.pause()));
        });
        const market = new URLSearchParams(window.location.search).get('market') || 'all';
        this.filter(['all', 'launch', 'import', 'used'].includes(market) ? market : 'all');
        const postHandle = new URLSearchParams(window.location.search).get('post');
        if (postHandle) {
          const targetDialog = Array.from(this.querySelectorAll('[data-post-dialog-handle]')).find((dialog) => dialog.dataset.postDialogHandle === postHandle);
          targetDialog?.showModal();
        }
      }
      filter(market) {
        this.querySelectorAll('[data-archive-filter]').forEach((button) => button.setAttribute('aria-selected', String(button.dataset.archiveFilter === market)));
        this.querySelectorAll('[data-archive-card]').forEach((card) => card.hidden = market !== 'all' && card.dataset.archiveCard !== market);
      }
      closeDialog(dialog) { dialog.close(); }
      step(dialog, direction) {
        const slides = Array.from(dialog.querySelectorAll('[data-dialog-slide]'));
        if (!slides.length) return;
        dialog.querySelectorAll('video').forEach((video) => video.pause());
        const index = (Number(dialog.dataset.index || 0) + direction + slides.length) % slides.length;
        dialog.dataset.index = String(index);
        slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tmw-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tmw-recently-viewed')) {
    customElements.define('tmw-recently-viewed', class extends HTMLElement {
      connectedCallback() {
        const key = 'tmw-recent-products';
        const current = this.dataset.currentHandle;
        let handles = [];
        try { handles = JSON.parse(localStorage.getItem(key) || '[]'); } catch (error) { handles = []; }
        handles = handles.filter((handle) => handle && handle !== current);
        const visibleHandles = handles.slice(0, Number(this.dataset.limit || 4));
        localStorage.setItem(key, JSON.stringify([current, ...handles].slice(0, 12)));
        if (!visibleHandles.length) return;
        Promise.all(visibleHandles.map((handle) => fetch(`${this.dataset.productUrl}${encodeURIComponent(handle)}.js`).then((response) => response.ok ? response.json() : null)))
          .then((products) => {
            products.filter(Boolean).forEach((product) => this.addProduct(product));
            if (this.querySelector('li')) this.hidden = false;
          })
          .catch(() => {});
      }
      addProduct(product) {
        const item = document.createElement('li');
        const link = document.createElement('a');
        const image = document.createElement('img');
        const title = document.createElement('strong');
        const price = document.createElement('span');
        link.className = 'tmw-recently-viewed__link';
        link.href = product.url;
        image.className = 'tmw-recently-viewed__image';
        image.src = product.featured_image || product.images?.[0] || '';
        image.alt = product.title;
        image.loading = 'lazy';
        title.className = 'tmw-recently-viewed__title';
        title.textContent = product.title;
        price.className = 'tmw-recently-viewed__price';
        price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'ja-JP', { style: 'currency', currency: this.dataset.currency }).format(product.price / 100);
        link.append(image, title, price);
        item.append(link);
        this.querySelector('ul').append(item);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tmw-triple-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tmw-post-rotator')) {
    customElements.define('tmw-post-rotator', class extends HTMLElement {
      connectedCallback() {
        this.posts = Array.from(this.querySelectorAll('[data-rotator-post]'));
        this.dots = Array.from(this.querySelectorAll('[data-rotator-dot]'));
        this.postIndex = 0;
        this.mediaIndex = 0;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.showPost(Number(dot.dataset.rotatorDot))));
        this.showPost(0);
      }
      disconnectedCallback() { this.stop(); }
      stop() {
        window.clearTimeout(this.timer);
        this.querySelectorAll('video').forEach((video) => video.pause());
      }
      showPost(index) {
        this.stop();
        if (!this.posts.length) return;
        this.postIndex = index % this.posts.length;
        this.mediaIndex = 0;
        this.posts.forEach((post, postIndex) => post.classList.toggle('is-active', postIndex === this.postIndex));
        this.dots.forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === this.postIndex);
          if (dotIndex === this.postIndex) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
        this.showMedia();
      }
      showMedia() {
        const post = this.posts[this.postIndex];
        const media = Array.from(post.querySelectorAll('[data-rotator-media]'));
        if (!media.length) return;
        media.forEach((slide, mediaIndex) => slide.classList.toggle('is-active', mediaIndex === this.mediaIndex));
        if (this.reducedMotion) return;
        const video = media[this.mediaIndex].querySelector('video');
        if (video) {
          this.activeVideo = video;
          video.currentTime = 0;
          video.play().catch(() => {});
        }
        this.timer = window.setTimeout(() => this.advance(media.length), Number(this.dataset.duration));
      }
      advance(mediaCount) {
        this.stop();
        if (this.mediaIndex + 1 < mediaCount) {
          this.mediaIndex += 1;
          this.showMedia();
        } else {
          this.showPost((this.postIndex + 1) % this.posts.length);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
